module.exports = __webpack_public_path__ + "static/media/7A.cb37f91a.jpg";